import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { filterRequest } from "../../utilities/apiManager";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getInstallments = createAsyncThunk(
  "installments/getInstallments",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", owner, user, filter = {} } = args;
      const filterStr = filterRequest(filter);
      let url = `/installments?page=${page}&size=${size}`;
      if (query) url += `&query=${query}`;
      if (owner) url += `&owner=${owner}`;
      if (user) url += `&user=${user}`;
      url += filterStr;

      const { data } = await axiosInstance.get(url);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const installmentsSlice = createSlice({
  name: "installments",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getInstallments.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getInstallments.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getInstallments.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default installmentsSlice.reducer;